import {setInitialState} from '../../../utils/reducerOperations';
export const Default=()=>({
    sendEmailApi:setInitialState(),
    emailConfig:{}
});